export default __webpack_public_path__ + "29c80bae73398ffd0d1442b7b78f4f0c.png";